import styled from 'styled-components'

export const ValidationWrapper = styled.span`
  color: ${(props) => !props.$valid && props.theme.colorError};
`
